import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'components/ui/dialog/Dialog';
import translate from 'components/hoc/translate';
import { getRuleTypes } from 'helpers/rulesHelper';
import { MenuItem, RaisedButton, SelectField } from 'material-ui';

class AddRuleModal extends React.Component {
    constructor() {
        super();

        this.state = {
            selectedRule: null,
        };
    }

    onChange = (event, index, value) => {
        event.preventDefault();

        this.setState({
            selectedRule: value,
        });
    }

    render() {
        const { selectedRule } = this.state;
        const {
            onAddRule,
            onCloseModal,
            translate,
            type,
        } = this.props;
        const types = getRuleTypes(type);

        if (!types) {
            return null;
        }

        const actions = [
            <RaisedButton
                key='cancel'
                label={ translate('actions.close') }
                onTouchTap={ onCloseModal }
            />,
            <RaisedButton
                key='add'
                label={ translate('actions.add') }
                onTouchTap={ () => {
                    return onAddRule(selectedRule);
                } }
                primary={ true }
                style={ { marginLeft: 12 } }
            />,
        ];

        return (
            <Dialog
                actions={ actions }
                modal={ false }
                onRequestClose={ onCloseModal }
                open={ true }
                title={ translate(`resources.discounts.rules.${ type }`) }
            >

                <SelectField onChange={ this.onChange } value={ selectedRule } fullWidth={ true } hintText={ translate('actions.select') }>
                    {
                        types.map((type) => {
                            return (
                                <MenuItem
                                    key={ type }
                                    primaryText={ type }
                                    value={ type }
                                />
                            );
                        })
                    }
                </SelectField>

            </Dialog>
        );
    }
}

AddRuleModal.propTypes = {
    onAddRule: PropTypes.func.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
};

export default translate(AddRuleModal);


// WEBPACK FOOTER //
// ./src/pages/discounts/rules/AddRuleModal.js